import { autorun, observable } from 'mobx'; 
import { IAPIBenefitsModels, IAPIItemSelectedBenefitsRequest } from '../interfaces'; 
import { getNewErrors, nameof } from '@mindmemobile/mm-shared-global';

export class BenefitsModel {
    id: string;
    @observable singularName: string;
    @observable pluralName: string;
    errors: any[];
    constructor(data?: Partial<BenefitsModel>) {
        this.id = (data && data.id) || '';
        this.singularName = (data && data.singularName) || '';
        this.pluralName = (data && data.pluralName) || '';
        this.errors = (data && data.errors) || [];
        autorun(() => {
            this.validate(true);
        });
    }

    validate = (isAutoRun = false): boolean => {
        const errors: any[] = [];
        if (!this.singularName || !this.singularName.trim()) {
            errors.push({ field: nameof<BenefitsModel>('singularName') });
        }
        if (!this.pluralName || !this.pluralName.trim()) {
            errors.push({ field: nameof<BenefitsModel>('pluralName') });
        }
        if (isAutoRun) {
            this.errors = getNewErrors(errors, this.errors);
        } else {
            this.errors = errors;
        }

        return this.errors.length === 0;
    };

    static deserializeAPIList(data: IAPIBenefitsModels[]): BenefitsModel[] {
        const list: BenefitsModel[] = [];

        if (Array.isArray(data)) {
            data.forEach((d) => {
                const mappedData = this.deserializeAPIModel(d);

                list.push(mappedData);
            });
        }
        return list;
    }

    static deserializeAPIModel(data: IAPIBenefitsModels): BenefitsModel {
        const mappedData: Partial<BenefitsModel> = {
            id: data.id,
            singularName: data.singularName,
            pluralName: data.pluralName,
        };
        return new BenefitsModel(mappedData);
    }

    createAPIModel(): IAPIItemSelectedBenefitsRequest {
        return {
            id: this.id,
            singularName: this.singularName,
            pluralName: this.pluralName,
        };
    }
}
